module.exports = __webpack_public_path__ + "media/promo/hochland/images/l1-91ebeb273104f4e1edc34e99b9cb4e1a.png";